/* NS UK Poland-matched product-card glow controller */
(() => {
  if (window.__nsUkCardGlowController) return;
  window.__nsUkCardGlowController = true;

  const cardSelector = 'product-card.ns-minimal-product-card';
  const runningClass = 'is-blade-glow-running';
  const completeClass = 'is-blade-glow-complete';
  const timers = new WeakMap();

  const clearCard = (card) => {
    const timer = timers.get(card);
    if (timer) clearTimeout(timer);
    timers.delete(card);
    card.classList.remove(runningClass, completeClass);
  };

  const clearOtherCards = (currentCard) => {
    document
      .querySelectorAll(`${cardSelector}.${runningClass}, ${cardSelector}.${completeClass}`)
      .forEach((card) => {
        if (card !== currentCard) clearCard(card);
      });
  };

  const startGlow = (card) => {
    clearCard(card);

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      card.classList.add(completeClass);
      return;
    }

    const duration = window.matchMedia('(max-width: 989px)').matches ? 2000 : 2800;
    card.classList.add(runningClass);
    timers.set(card, setTimeout(() => {
      card.classList.remove(runningClass);
      card.classList.add(completeClass);
      timers.delete(card);
    }, duration));
  };

  document.addEventListener('pointerover', (event) => {
    if (event.pointerType !== 'mouse') return;
    const card = event.target instanceof Element ? event.target.closest(cardSelector) : null;
    if (!card || (event.relatedTarget instanceof Node && card.contains(event.relatedTarget))) return;
    startGlow(card);
  });

  document.addEventListener('pointerout', (event) => {
    if (event.pointerType !== 'mouse') return;
    const card = event.target instanceof Element ? event.target.closest(cardSelector) : null;
    if (!card || (event.relatedTarget instanceof Node && card.contains(event.relatedTarget))) return;
    if (!card.matches(':focus-within')) clearCard(card);
  });

  document.addEventListener('focusin', (event) => {
    const card = event.target instanceof Element ? event.target.closest(cardSelector) : null;
    if (card) startGlow(card);
  });

  document.addEventListener('focusout', (event) => {
    const card = event.target instanceof Element ? event.target.closest(cardSelector) : null;
    if (!card || (event.relatedTarget instanceof Node && card.contains(event.relatedTarget))) return;
    if (!card.matches(':hover')) clearCard(card);
  });

  document.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
    const card = event.target instanceof Element ? event.target.closest(cardSelector) : null;
    clearOtherCards(card);
    if (card) startGlow(card);
  }, { passive: true });
})();

/* NS UK Poland-matched product-card glow loader */
(() => {
  if (window.__nsUkCardGlowLoader) return;
  window.__nsUkCardGlowLoader = true;

  const cardSelector = 'product-card.ns-minimal-product-card';
  const activeSelector = `${cardSelector}.is-blade-glow-running, ${cardSelector}.is-blade-glow-complete`;
  const frameTargetSelector = '.ns-minimal-product-card__link';

  const ensureFrame = (card) => {
    if (!(card instanceof HTMLElement)) return;

    const frameTarget = card.querySelector(frameTargetSelector);
    if (!(frameTarget instanceof HTMLElement)) return;

    let frame = frameTarget.querySelector(':scope > .ns-card-glow-frame');
    if (!frame) {
      frame = document.createElement('span');
      frame.className = 'ns-card-glow-frame';
      frame.setAttribute('aria-hidden', 'true');
      frameTarget.append(frame);
    }

    for (const side of ['top', 'right', 'bottom', 'left']) {
      if (frame.querySelector(`:scope > .ns-card-glow-edge--${side}`)) continue;
      const edge = document.createElement('i');
      edge.className = `ns-card-glow-edge ns-card-glow-edge--${side}`;
      frame.append(edge);
    }

    for (const strength of ['primary', 'secondary']) {
      if (frame.querySelector(`:scope > .ns-card-clash--${strength}`)) continue;
      const clash = document.createElement('span');
      clash.className = `ns-card-clash ns-card-clash--${strength}`;

      for (let spark = 0; spark < 8; spark += 1) {
        const particle = document.createElement('b');
        particle.className = 'ns-card-clash-spark';
        clash.append(particle);
      }

      frame.append(clash);
    }
  };

  const cardFromEvent = (event) => event.target instanceof Element
    ? event.target.closest(cardSelector)
    : null;

  document.addEventListener('pointerover', (event) => {
    const card = cardFromEvent(event);
    if (card) ensureFrame(card);
  }, true);

  document.addEventListener('pointerdown', (event) => {
    const card = cardFromEvent(event);
    if (card) ensureFrame(card);
  }, { capture: true, passive: true });

  document.addEventListener('focusin', (event) => {
    const card = cardFromEvent(event);
    if (card) ensureFrame(card);
  }, true);

  new MutationObserver((records) => {
    for (const record of records) {
      if (record.target instanceof HTMLElement && record.target.matches(activeSelector)) {
        ensureFrame(record.target);
      }
    }
  }).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
    subtree: true,
  });

  document.querySelectorAll(activeSelector).forEach(ensureFrame);
})();
